._clientOfersContainer_f748u_1 {
  width: 100%;
}
._clientOfersContainer_f748u_1 ._sampleCsvUrl_f748u_4 a {
  color: #1890ff;
}
._clientOfersContainer_f748u_1 ._uploadButton_f748u_7 {
  margin-bottom: 15px;
  color: #1890ff;
}